module.exports = __webpack_public_path__ + "static/020_001-26593b7f40b2736802076f2094ed60b0.jpg";